export default {
  ft: {to_meter: 0.3048},
  'us-ft': {to_meter: 1200 / 3937}
};
